import { Button, XStack } from '@mythical/ui'
import { Frequency } from 'app/queries/tiers/member-tiers'

import { TierTheme } from './themes'

const FREQUENCY_LABELS: Record<Frequency, string> = {
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  annually: 'Yearly',
}

interface FrequencyToggleProps {
  onChange: (frequency: Frequency) => void
  options: Frequency[]
  selected: Frequency
  theme: TierTheme
}

export const FrequencyToggle = ({
  onChange,
  options,
  selected,
  theme,
}: FrequencyToggleProps) => (
  <XStack
    borderColor={theme.toggleBorderColor}
    borderWidth={2}
    br="$pill"
    p={2}
    gap="$1"
  >
    {options.map((freq) => {
      const isActive = selected === freq
      const buttonTheme = isActive ? theme.toggleTheme : 'transparent'

      return (
        <Button
          key={freq}
          theme={buttonTheme}
          br="$pill"
          onPress={() => onChange(freq)}
          px="$3"
          py="$2"
          cursor="pointer"
          size="$3"
          $gtXxs={{ px: '$5', py: '$3' }}
          $gtLg={{ px: '$9.5', py: '$3' }}
          textProps={{
            fow: '500',
            ...(!isActive && { color: theme.toggleInactiveColor }),
          }}
        >
          {FREQUENCY_LABELS[freq]}
        </Button>
      )
    })}
  </XStack>
)
